import { render, staticRenderFns } from "./SimulatorTeach.vue?vue&type=template&id=5dfa9560&scoped=true&"
import script from "./SimulatorTeach.vue?vue&type=script&lang=js&"
export * from "./SimulatorTeach.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorTeach.vue?vue&type=style&index=0&id=5dfa9560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa9560",
  null
  
)

export default component.exports